import classNames from 'classnames'
import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import type { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import { TRANSLATION_KEYS } from '../../configs/translations'

import { ActionCardType, IAction } from './models'

import styles from './Requirements.module.scss'

interface IRequirementsGetStartedProps {
  cards: IAction[]
  onAction: (action: ActionCardType) => void
  placeholder?: ReactNode
}

export const RequirementsGetStarted = ({
  cards,
  onAction,
  placeholder,
}: IRequirementsGetStartedProps) => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionTitle}>
        <Translation text={TRANSLATION_KEYS.requirements.getStarted} />
      </div>

      {placeholder ?? (
        <div className={styles.actionGrid}>
          {cards.map((card) => (
            <P360Card
              key={card.titleKey}
              className={classNames(
                styles.actionCard,
                card.isHighlighted && styles['actionCard--highlighted']
              )}
              bodyClassName={styles.actionCardBody}
              fullHeight
            >
              <div className={styles.actionCard__wrapper} onClick={() => onAction(card.action)}>
                <div
                  className={classNames(
                    styles.actionCard__icon,
                    card.isHighlighted && styles['actionCard__icon--highlighted']
                  )}
                >
                  <i className={card.icon} />
                </div>

                <div className={styles.actionCard__content}>
                  <div className={styles.actionCard__title}>
                    <Translation text={card.titleKey} />
                  </div>

                  <div className={styles.actionCard__description}>
                    <Translation text={card.descriptionKey} />
                  </div>
                </div>
              </div>
            </P360Card>
          ))}
        </div>
      )}
    </section>
  )
}
